const DEFAULT_PRIMARY = '#3498DB';
const normalizeHex = (value, fallback = DEFAULT_PRIMARY) => {
    const trimmed = (value || '').trim();
    if (!trimmed)
        return fallback;
    const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
    if (/^#([A-Fa-f0-9]{6})$/.test(withHash))
        return withHash.toUpperCase();
    if (/^#([A-Fa-f0-9]{3})$/.test(withHash)) {
        const [, short] = withHash.match(/^#([A-Fa-f0-9]{3})$/) || [];
        if (!short)
            return fallback;
        return `#${short.split('').map((c) => c + c).join('')}`.toUpperCase();
    }
    return fallback;
};
/** Erster sichtbarer Buchstabe des Projektnamens (Unicode-sicher). */
export const getProjectInitial = (projectName) => {
    const trimmed = (projectName || '').trim();
    if (!trimmed)
        return 'R';
    const stripped = trimmed.replace(/^[^\p{L}\p{N}]+/u, '');
    const source = stripped || trimmed;
    const match = source.match(/\p{L}|\p{N}/u);
    return (match?.[0] || source.charAt(0) || 'R').toUpperCase();
};
export const buildLetterFaviconDataUrl = (letter, backgroundColor) => {
    const bg = normalizeHex(backgroundColor);
    const char = letter.slice(0, 1).toUpperCase();
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" role="img" aria-label="${char}">
  <rect width="32" height="32" rx="6" fill="${bg}"/>
  <text x="16" y="17" text-anchor="middle" dominant-baseline="middle" fill="#FFFFFF" font-family="Inter, Arial, sans-serif" font-size="17" font-weight="700">${char}</text>
</svg>`;
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};
export const inferFaviconMimeType = (url) => {
    try {
        const pathname = new URL(url, 'https://local.invalid').pathname.toLowerCase();
        if (pathname.endsWith('.png'))
            return 'image/png';
        if (pathname.endsWith('.jpg') || pathname.endsWith('.jpeg'))
            return 'image/jpeg';
        if (pathname.endsWith('.webp'))
            return 'image/webp';
        if (pathname.endsWith('.svg'))
            return 'image/svg+xml';
        if (pathname.endsWith('.ico'))
            return 'image/x-icon';
    }
    catch {
        // ignore
    }
    if (url.startsWith('data:image/svg'))
        return 'image/svg+xml';
    if (url.startsWith('data:image/png'))
        return 'image/png';
    return 'image/png';
};
export const resolveProjectFaviconUrl = (input) => {
    const custom = (input.faviconUrl || '').trim();
    if (custom)
        return custom;
    return buildLetterFaviconDataUrl(getProjectInitial(input.projectName), normalizeHex(input.primaryColor));
};
const FAVICON_LINK_SELECTOR = 'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]';
/** Ersetzt alle Favicon-Links durch Upload-URL oder generiertes Initial-Badge. */
export const applyProjectFavicon = (input) => {
    if (typeof document === 'undefined')
        return;
    const href = resolveProjectFaviconUrl(input);
    const type = inferFaviconMimeType(href);
    document.querySelectorAll(FAVICON_LINK_SELECTOR).forEach((node) => node.remove());
    const specs = [
        { rel: 'icon', type },
        { rel: 'shortcut icon', type },
        { rel: 'apple-touch-icon', type }
    ];
    for (const spec of specs) {
        const link = document.createElement('link');
        link.rel = spec.rel;
        if (spec.type)
            link.type = spec.type;
        link.href = href;
        document.head.appendChild(link);
    }
};
